import React from 'react'
import NoData from '@/components/common/NoData'
import LoadingSpinner from '@/components/common/LoadingSpinner'
import GeneralError from '@/components/common/GeneralError'
import DatabaseTable from '@/components/pages/JobsPage/DatabaseTable'

type DatabaseTabProps = {
    databaseJobs: any,
    databasesLoading: boolean,
    databasesError: boolean,
}

const DatabaseTab = ({databaseJobs, databasesLoading, databasesError}: DatabaseTabProps) => {

    if(databasesLoading) {
        return <LoadingSpinner />
    }

    if(databasesError) {
        return <GeneralError />
    }

    if(!databaseJobs) {
        return <NoData message="No database jobs found."/>
    }

    return <DatabaseTable jobs={databaseJobs || []}/>
}

export default DatabaseTab